import { SITE } from "./site";

export const SERVICES = [
  {
    slug: "corporate-travel",
    name: "Corporate Travel",
    tagline: "Executive transportation for the modern boardroom.",
    short: "Discreet, on-time executive transport for C-suites, government contractors, embassies and law firms.",
    hero: SITE.sedanMercedes,
    points: [
      "Dedicated executive chauffeurs",
      "Priority dispatch & monthly billing",
      "Confidentiality and NDA-ready service",
      "Embassy, law-firm and government accounts",
    ],
    audience: ["Executives", "Government Contractors", "Law Firms", "Embassies", "Corporate Accounts"],
  },
  {
    slug: "tourism-sightseeing",
    name: "Tourism & Sightseeing",
    tagline: "Washington DC, the luxury way.",
    short: "Private, chauffeured DC tours: monuments, museums, and hidden gems — at your pace.",
    hero: SITE.jefferson,
    points: [
      "Customizable DC monument tours",
      "Multilingual chauffeurs on request",
      "Hourly and full-day packages",
      "Group sightseeing in luxury vans & coaches",
    ],
    audience: ["Families", "International Visitors", "VIP Tour Groups", "Embassies"],
  },
  {
    slug: "special-events",
    name: "Special Events",
    tagline: "Arrive in unforgettable style.",
    short: "Weddings, galas, private events, and VIP gatherings — flawless logistics from start to finish.",
    hero: SITE.heroFleet,
    points: [
      "Wedding day coordination & getaway car",
      "Bridal party transport with sprinters & limos",
      "Gala & charity event shuttle service",
      "Red-carpet arrivals & VIP gatherings",
    ],
    audience: ["Weddings", "Galas", "Private Parties", "VIP Events"],
  },
  {
    slug: "sporting-events-concerts",
    name: "Sporting Events & Concerts",
    tagline: "Skip traffic. Skip parking. Skip the wait.",
    short: "Luxury group transport to stadiums, arenas and concert venues across the DMV.",
    hero: SITE.dcBridge,
    points: [
      "Group transportation to all DMV venues",
      "Tailgate-friendly sprinter vans",
      "Late-night safe return service",
      "Hourly standby & block bookings",
    ],
    audience: ["Sports Fans", "Concert Groups", "Corporate Outings"],
  },
  {
    slug: "local-rides",
    name: "Local Rides",
    tagline: "Daily luxury, on demand.",
    short: "Premium point-to-point transportation throughout DC, Virginia and Maryland.",
    hero: SITE.suvInterior,
    points: [
      "Point-to-point and hourly service",
      "Sedan, SUV and Sprinter options",
      "Pre-booked priority pickups",
      "24/7 availability throughout DMV",
    ],
    audience: ["Daily Commuters", "Dinner Reservations", "Medical Appointments"],
  },
  {
    slug: "wine-tours",
    name: "Wine Tours",
    tagline: "Virginia's wine country — uncorked.",
    short: "Curated, chauffeured wine tours across Loudoun, Middleburg and beyond.",
    hero: SITE.vanFord,
    points: [
      "Curated multi-winery itineraries",
      "Sedans, SUVs and luxury sprinters",
      "Private group bookings",
      "Picnic & lunch coordination on request",
    ],
    audience: ["Couples", "Bachelor/ette Parties", "Corporate Retreats"],
  },
  {
    slug: "coaches-buses",
    name: "Coaches & Buses",
    tagline: "Group transportation, executive-class.",
    short: "Shuttle buses and motor coaches for conferences, weddings and corporate roadshows.",
    hero: SITE.coachExecutive,
    points: [
      "Mini-coaches (20–30 pax)",
      "Full motor coaches (40–56 pax)",
      "Conference & convention logistics",
      "Multi-vehicle coordination",
    ],
    audience: ["Conferences", "Conventions", "Large Weddings", "School Trips"],
  },
  {
    slug: "armed-security-transportation",
    name: "Armed Security Transportation",
    tagline: "Luxury meets executive protection.",
    short: "Vetted executive protection chauffeurs for high-value clients, dignitaries and VIPs.",
    hero: SITE.suvLineup,
    points: [
      "Licensed, vetted EP chauffeurs",
      "Discreet motorcades on request",
      "Embassy & dignitary experience",
      "Threat-aware route planning",
    ],
    audience: ["Dignitaries", "Public Figures", "Executives", "Family Office Clients"],
  },
];

export const findService = (slug) => SERVICES.find((s) => s.slug === slug);
